import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useOrganization } from '../contexts/OrganizationContext';
import { usePermissions } from '../hooks/usePermissions';
import { CircularProgress, Box } from '@mui/material';

interface AdminOwnerProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminOwnerProtectedRoute = ({ children }: AdminOwnerProtectedRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const { currentOrganization, loading: orgLoading } = useOrganization();
  const { isOwner, isAdmin, loading: permissionsLoading } = usePermissions();

  if (authLoading || orgLoading || permissionsLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se o usuário é owner (tanto por ownerId quanto por role) ou admin
  const isOwnerById = currentOrganization?.ownerId === user.uid;

  if (!isOwner && !isOwnerById && !isAdmin) {
    // Redirecionar para dashboard se não for admin nem owner
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
